// auto-generated by bin/genVersion.ts
export const VERSION = '2.7.1';
//# sourceMappingURL=version.js.map